import { render, staticRenderFns } from "./accreditationDialog.vue?vue&type=template&id=3f430f95&scoped=true"
import script from "./accreditationDialog.vue?vue&type=script&lang=js"
export * from "./accreditationDialog.vue?vue&type=script&lang=js"
import style0 from "./accreditationDialog.vue?vue&type=style&index=0&id=3f430f95&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f430f95",
  null
  
)

export default component.exports